<template>
  <div class="page-content expense-details clearfixing">

    <!-- BREADCRUMB -->
    <f-p-breadcrumb
      :breadcrumbOuter="$lang.messages.payments.toUpperCase()"
      :breadcrumbTo="routeLeadsTo"
      :breadcrumbToTitle="routeLeadsToTitle"
      :breadcrumbInner="$lang.messages.expenseDetails.toUpperCase()"
      :breadcrumbIsHistory="true">
    </f-p-breadcrumb>

    <fp-expense-details
      :type="type"
      :guid="guid"
      :queryPay="queryPay"
      @status-payment="status"
      class="clearfixing">
    </fp-expense-details>
  </div>
</template>

<script>
import FpExpenseDetails from '@/components/common/FPExpensesDetails';
import FPBreadcrumb from "@/components/common/FPBreadcrumb";

export default {
  name: "childMaintenanceExpenseDetails",
  components: {
    FpExpenseDetails,
    'f-p-breadcrumb': FPBreadcrumb
  },
  props: {
    routeLeadsTo: {
      type: String,
      required: true
    },
    routeLeadsToTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      type: this.$CHILD_EXPENSE_TYPE,
      guid: this.$route.params.id,
      queryPay: this.$route.query.pay,
      paymentStatus: ''
    };
  },
  mounted() {
    this.expenseStatus();
  },
  methods: {
    status(val) {
      this.paymentStatus = val;
    },
    expenseStatus () {
      this.$emit('expenseStatus', this.$route.params.expenseStatus);
    }
  }
};
</script>
